module.exports = __webpack_public_path__ + "img/bottom.96b33703.webp";